/**
 * Schema of AlertaCarga
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {datetime} from 'simpli-web-sdk'
import AlertaCarga from '@/model/resource/AlertaCarga'

export default (model: AlertaCarga): Schema => ({
  alerta: {
    content: model.alerta && model.alerta.descricao || '',
    input: InputType.SELECT,
  },

  cargaDestinatario: {
    content: model.carga && model.carga.destinatario && model.carga.destinatario.$tag || '',
    input: InputType.SELECT,
  },

  cargaNroNotaFiscal: {
    content: model.carga && model.carga.nroNotaFiscal || '',
    input: InputType.SELECT,
  },

  motorista: {
    content: model.motorista && model.motorista.$tag || '',
    input: InputType.SELECT,
  },

  idAlertaCargaPk: {
    content: model.idAlertaCargaPk,
    hidden: true,
    editable: false,
  },

  dataAlerta: {
    content: datetime(model.dataAlerta),
    input: InputType.DATETIME,
    meta: {
      required: true,
    },
  },
})
